export enum QueryKey {
    Business = 'Business',
    BusinessLogo = 'BusinessLogo',
    Documents = 'Documents',
    DocumentDrawer = 'DocumentDrawer',
    FixedAssets = 'FixedAssets',
    PartnerDemo = 'PartnerDemo',
    PartnerTransactions = 'PartnerTransactions',
    VatDeclarationSnapshots = 'VatDeclarationSnapshots',
    VatDeclarationDraft = 'VatDeclarationDraft',
}
